import { toJS } from "mobx";
import { useCallback, useMemo } from "react";
import {
  addNisSign,
  numberWithCommas,
} from "../../../services/calculattions-service";
import { useStore } from "../../../store";
import Classes from "./ProjectionSummaryDisplay.module.scss";

const ProjectionSummaryDisplay = () => {
  const { context } = useStore();

  const projectionSummaryParamters = useMemo(() => {
    const projectionSummaryData = toJS(context.investmentSummary)[
      toJS(context.investmentSummary).length - 1
    ];
    const investmentValue = parseInt(
      projectionSummaryData.balance.replaceAll(",", "").replaceAll("₪", "")
    );
    const investmentValueWithoutFees = projectionSummaryData.balanceWithoutFees 
      ? parseInt(projectionSummaryData.balanceWithoutFees.replaceAll(",", "").replaceAll("₪", ""))
      : investmentValue;
    
    const totalDeposits = context.monthlyDeposit * context.numberOfYears * 12;
    const totalEarnings = Math.round(
      investmentValue - context.principal - totalDeposits
    );
    
    const parameters = [
      {
        title: "השקעה ראשונית",
        value: addNisSign(numberWithCommas(context.principal)),
      },
      {
        title: "סה״כ הפקדות",
        value: addNisSign(numberWithCommas(totalDeposits)),
      },
      {
        title: "סה״כ רווח",
        value: addNisSign(numberWithCommas(totalEarnings)),
      },
    ];

    // Add management fees related parameters if fees are enabled
    if (context.managementFeesEnabled) {
      parameters.push({
        title: "הסכום הצפוי בסוף התקופה (ללא דמי ניהול)",
        value: addNisSign(numberWithCommas(investmentValueWithoutFees)),
      });
      parameters.push({
        title: "הסכום הצפוי בסוף התקופה",
        value: addNisSign(numberWithCommas(investmentValue)),
      });
      parameters.push({
        title: "סך דמי הניהול שנגבו מהפקדה",
        value: addNisSign(numberWithCommas(context.totalDepositFees)),
      });
      parameters.push({
        title: "סך דמי הניהול שנגבו מצבירה",
        value: addNisSign(numberWithCommas(context.totalAccumulationFees)),
      });
    } else {
      parameters.push({
        title: "סכום סופי בסוף התקופה",
        value: addNisSign(numberWithCommas(investmentValue)),
      });
    }

    return parameters;
  }, [
    context.investmentSummary,
    context.monthlyDeposit,
    context.numberOfYears,
    context.principal,
    context.managementFeesEnabled,
    context.totalDepositFees,
    context.totalAccumulationFees,
  ]);

  const renderProjectionParamater = useCallback(
    (title: string, value: string | number, index: number) => {
      return (
        <div className={Classes.projectionParameterWrapper} key={index}>
          <div className={Classes.title}>{title}</div>
          <div className={Classes.value}>{value}</div>
        </div>
      );
    },
    []
  );

  return (
    <div className={Classes.projectionParametersWrapper}>
      {projectionSummaryParamters.map((parameter, index) => {
        return renderProjectionParamater(
          parameter.title,
          parameter.value,
          index
        );
      })}
    </div>
  );
};

export default ProjectionSummaryDisplay;
